import { Button, Heading } from "@athena/forge";
import React from "react";
import { useTranslation } from "react-i18next";
import { logRemoveFactorInitiated } from "../../lib/amplitude-utils";

export interface EnrolledFactorProps {
  id: string;
  factorName: string;
  enrolledNumber?: string;
  deviceLabel?: string;
  icon: string;
  removeFactorHandler: (factorId: string) => Promise<void>;
}

const EnrolledFactor = ({
  id,
  factorName,
  enrolledNumber,
  deviceLabel,
  icon,
  removeFactorHandler,
}: EnrolledFactorProps): React.JSX.Element => {
  const { t } = useTranslation();
  const [isDisabled, setIsDisabled] = React.useState(false);
  const handleRemoveButtonClick = async (e: React.MouseEvent): Promise<void> => {
    e.preventDefault();
    setIsDisabled(true);
    logRemoveFactorInitiated({ factorName });
    try {
      await removeFactorHandler(id);
    } finally {
      setIsDisabled(false);
    }
  };
  return (
    <div className="uiam-edit-factor-row">
      <div className="enroll-factor-row clearfix">
        <div className="enroll-factor-icon-container fe_u_margin--right-medium">
          <div className={`factor-icon enroll-factor-icon ${icon}`}></div>
        </div>
      </div>
      <div>
        <div className="uiam-enrolled-factor-container">
          <Heading
            headingTag="h3"
            variant="section"
            text={factorName}
            className="fe_u_font-size--default"
          />
          <Button
            text="Remove"
            variant="secondary"
            size="medium"
            onClick={handleRemoveButtonClick}
            disabled={isDisabled}
          />
        </div>
        {(enrolledNumber || deviceLabel) && (
          <ul className="fe_u_font-size--small fe_u_margin--left-small fe_u_margin--top-small">
            {enrolledNumber && (
              <li className="uiam-enrolled-factor-detail-list-item">
                <span className="fe_u_font-weight--semibold">
                  {t("managefactors.factor.enrollednumber") + " "}
                </span>
                {enrolledNumber}
              </li>
            )}
            {deviceLabel && (
              <li className="uiam-enrolled-factor-detail-list-item">
                <span className="fe_u_font-weight--semibold">
                  {t("managefactors.factor.enrolledmethod") + " "}
                </span>
                {deviceLabel}
              </li>
            )}
          </ul>
        )}
      </div>
    </div>
  );
};

export default EnrolledFactor;
